import { BookingType } from '@shared/transactions-types';

import { isBookingType } from './isBookingType';

export const isRoundingDonationTransaction = isBookingType(
    BookingType.EL_SPENDE_EPA,
    BookingType.EL_SPENDE_SB,
);
